<template>
  <div>
    <breadcrumbs :back="back" home="Reconciliation transactions"/>

    <purtrak-table name="reconcilevesseltransactions" objectType="reconcile transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table"
                   :nonPagedItems="exciseVesselReconciliation.transactions" listEndPoint="" fields=""
                   height="calc(100vh - 152px)"
                   @dblclick="item => viewTransaction(item)"
                   title="Reconciliation"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[$formatDateTime(exciseVesselReconciliation.date),sites.length>1?exciseVesselReconciliation.site.name:null]}">
      <template v-slot:filter>
        <div class="text-caption mr-1">{{exciseVesselReconciliation.date | formatDateTime}}</div>
        <div v-if="sites.length > 1" class="text-caption mr-1">{{exciseVesselReconciliation.site.name}}</div>
      </template>

      <template v-slot:item.volume="{item,value,printing}">
        <template v-if="printing">{{volume | number(3)}} {{item.units}}</template>
        <span :class="{'red--text':value<0}">{{value | number(item.precision)}} {{item.units}}</span>
      </template>
      <template v-slot:item.value="{value,printing}">
        <template v-if="printing">{{value | currency}}</template>
        <span :class="{'red--text':value<0}">{{value | currency}}</span>
      </template>
      <template v-slot:item.action="{item}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="viewTransaction(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item
                        :to="{name:'ReportsView',params:{back:[...back,{text:'Item reconciliation transactions',to:{name:'ExciseVesselReconcileTransactions',params:{id}}}]},query:{to:'reports/inventory/ReportsLot',id:item.id,lot:item.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:item.id}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=item;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" name="this transaction" @delete="performDeleteTransaction"/>
  </div>
</template>

<script>

export default {
  name: 'ExciseVesselReconcileTransactions',
  props: {
    id: {type:String, required:true}
  },
  data() {
    return {
      exciseVesselReconciliation: {transactions:[],site:{}},
      transaction: null,
      showDelete: false,
      defaultColumns: [{ value: 'name', visible:true},
                       { value: 'description', visible:true},
                       { value: 'volume', visible:true},
                       { value: 'value', visible:false}],
      headers: [{ text: 'ITEM', value: 'name', width:'30%',sortable:false},
                { text: 'ACTIVITY', value: 'description', width:'30%',sortable:false},
                { text: 'VOLUME', value: 'volume', width:'20%',sortable:true,align:'right'},
                { text: 'VALUE', value: 'value', width:'20%',sortable:true,align:'right',omit:() =>!this.values}]
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    sites() {
      return this.$store.getters.sites(true, this.exciseVesselReconciliation.bonded ? {B263:true,B265:true,B266:true} : undefined);
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('inventory.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    back() {
      return [this.exciseVesselReconciliation.type === 'Tank' ? {text:'Tanks',to:{name:'EquipmentTanks'}} :
                                                            {text:'Bulk containers',to:{name:'InventoryBulkContainers'}},
              {text:'Reconciliations',to:{name:'ExciseVesselReconcile',params:{type:this.exciseVesselReconciliation.type}}}];
    }
  },
  async mounted() {
    this.loading = true;
    const results = await this.$apiCall(`query ExciseVesselReconcileTransactions($id:ID!) {
                                              exciseVesselReconciliation(id:$id) {
                                                date,site{name},type
                                                transactions {
                                                  id,name,description,volume,units,value
                                                }
                                              }
                                            }`,
                                        {id:this.id});
    if (!results.error)
      this.exciseVesselReconciliation = results.data.exciseVesselReconciliation;
    this.loading = false;
  },
  methods: {
    viewTransaction(transaction) {
      this.$router.push({name:'ExciseVesselAdjustInventory',params:{transactionId:transaction.id}});
    },
    async performDeleteTransaction() {
      this.loading = true;
      const results = await this.$apiCall(`mutation ExciseVesselReconcileTransactions($id: ID!) {
                                            objectDelete(id:$id)
                                          }`,
                                          {id:this.transaction.id});
      this.loading = false;
      if (!results.error) {
        this.showDelete = false;
        this.$refs.table?.buildList();
        this.$store.commit('setError', {type:'success',message:`Deleted ${this.transaction.description} transaction`});
      }
    }
  }
}
</script>